import { Divider, Stack, Typography } from '@mui/material';
import { OneOrTwoButtons } from 'Components/OneOrTwoButtons';
import { UploadPrescription } from 'Images';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { differenceInDays } from 'date-fns';
import { IRecommendations } from 'API/Home/recommendations';
import { useNavigate } from 'react-router-dom';

interface IMedicationList {
  data: IRecommendations;
}

export const MedicationList = ({ data }: IMedicationList) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).remindYou;
  const isDesktop = useIsDesktop();

  const daysRemaining = (nextRefreshDate: Date) => {
    const today = new Date();
    const refreshDate = new Date(nextRefreshDate);
    const difference = differenceInDays(refreshDate, today);
    return Math.max(0, difference);
  };

  const navigate = useNavigate();

  return (
    <Stack
      p={isDesktop ? '40px 32px 48px' : '0'}
      bgcolor={'white'}
      height={'100%'}
      borderRadius={'16px'}
      justifyContent={'space-between'}
    >
      <Stack
        gap={'24px'}
        mb={isDesktop ? 4 : 2}
        p={isDesktop ? undefined : '24px'}
      >
        <Typography variant='h5'>
          {dictionary.youHave} <strong>{data.entityJSON.items.length}</strong>{' '}
          {dictionary.medicationsToRenew}
        </Typography>
        <Stack gap={'8px'}>
          {data.entityJSON.items.map((medication) => (
            <Stack>
              <Stack
                flexDirection='row'
                justifyContent='space-between'
                p='20px 0'
              >
                <Typography variant='body3'>
                  {medication.medicationName}
                </Typography>
                <Typography variant='body5'>
                  {medication.nextRefreshDate &&
                    daysRemaining(medication.nextRefreshDate) > 0 &&
                    dictionary.daysRemaining(
                      daysRemaining(medication.nextRefreshDate)
                    )}
                </Typography>
              </Stack>
              <Divider
                flexItem
                sx={{ borderColor: 'primary.shade_100' }}
                aria-hidden='true'
              />
            </Stack>
          ))}
        </Stack>
      </Stack>
      <OneOrTwoButtons
        width='max-content'
        leftButton={{
          label: dictionary.requestPrescription,
          onClick: () => {
            navigate('universalRequest/1/1/77');
          },
        }}
        rightButton={{
          label: dictionary.uploadNewPrescription,
          onClick: () => {
            navigate('universalRequest/1/6/94');
          },
          icon: UploadPrescription,
        }}
        isMobileVersion={!isDesktop}
      />
    </Stack>
  );
};
